var _g, _g2, _g3, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbroad02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_7",
    "data-name": 7,
    xmlns: "http://www.w3.org/2000/svg",
    width: 151.6,
    height: 76.058,
    viewBox: "0 0 151.6 76.058",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2573",
    "data-name": "Group 2573",
    transform: "translate(3.548 30.88)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2569",
    "data-name": "Group 2569",
    transform: "translate(1.356 15.509)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4170",
    "data-name": "Path 4170",
    d: "M69.455,158.6l102.38,4.485,38.586-26.725-79.492-2.945Z",
    transform: "translate(-69.455 -133.419)",
    fill: "#b6bec5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2570",
    "data-name": "Group 2570",
    transform: "translate(0 11.315)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4171",
    "data-name": "Path 4171",
    d: "M68.5,155.648l102.38,4.486,38.585-26.725-79.492-2.945Z",
    transform: "translate(-68.5 -130.464)",
    fill: "#dee6ed"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2571",
    "data-name": "Group 2571",
    transform: "translate(0.259 5.296)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4172",
    "data-name": "Path 4172",
    d: "M68.682,151.408l102.38,4.486,38.586-26.725-79.491-2.944Z",
    transform: "translate(-68.682 -126.225)",
    fill: "#b6bec5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2572",
    "data-name": "Group 2572",
    transform: "translate(3.426)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4173",
    "data-name": "Path 4173",
    d: "M70.913,147.679l102.38,4.485,38.585-26.725-79.492-2.945Z",
    transform: "translate(-70.913 -122.494)",
    fill: "#dee6ed"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2580",
    "data-name": "Group 2580",
    transform: "translate(3.772 6.612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2574",
    "data-name": "Group 2574",
    transform: "translate(0 21.327)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4174",
    "data-name": "Path 4174",
    d: "M68.657,145.607l86.534,3.791,15.846.695,38.586-26.725-79.492-2.945Z",
    transform: "translate(-68.657 -120.423)",
    fill: "#b6bec5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2575",
    "data-name": "Group 2575",
    transform: "translate(3.164 15.705)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4175",
    "data-name": "Path 4175",
    d: "M70.885,141.647l102.38,4.485,38.586-26.725-79.492-2.945Z",
    transform: "translate(-70.885 -116.463)",
    fill: "#dee6ed"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2576",
    "data-name": "Group 2576",
    transform: "translate(3.423 9.687)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4176",
    "data-name": "Path 4176",
    d: "M71.068,137.408l102.38,4.485,38.585-26.725-79.492-2.945Z",
    transform: "translate(-71.068 -112.223)",
    fill: "#b6bec5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2577",
    "data-name": "Group 2577",
    transform: "translate(6.589 4.391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4177",
    "data-name": "Path 4177",
    d: "M73.3,133.677l102.381,4.485,38.585-26.725-79.492-2.945Z",
    transform: "translate(-73.298 -108.493)",
    fill: "#dee6ed"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2579",
    "data-name": "Group 2579",
    transform: "translate(6.863)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4178",
    "data-name": "Path 4178",
    d: "M73.491,130.584l102.38,4.486,38.585-26.725L134.965,105.4Z",
    transform: "translate(-73.491 -105.4)",
    fill: "#b6bec5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2578",
    "data-name": "Group 2578",
    transform: "translate(20.04 2.841)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4179",
    "data-name": "Path 4179",
    d: "M87.608,120.916l78.519,3.342,3.943-2.545L93.289,118.5Z",
    transform: "translate(-87.608 -102.745)",
    fill: "#a2a8b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4180",
    "data-name": "Path 4180",
    d: "M95.309,117.574l75.172,3.106,3.6-2.322-73.578-3Z",
    transform: "translate(-84.376 -104.061)",
    fill: "#a2a8b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4181",
    "data-name": "Path 4181",
    d: "M102.356,114.517l72.1,2.9,3.3-2.127-70.631-2.8Z",
    transform: "translate(-81.419 -105.267)",
    fill: "#a2a8b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4182",
    "data-name": "Path 4182",
    d: "M108.829,111.712l69.266,2.711,3.033-1.957-67.91-2.624Z",
    transform: "translate(-78.703 -106.376)",
    fill: "#a2a8b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4183",
    "data-name": "Path 4183",
    d: "M114.794,109.128l66.647,2.544,2.8-1.805L118.85,107.4Z",
    transform: "translate(-76.2 -107.401)",
    fill: "#a2a8b1"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2583",
    "data-name": "Group 2583",
    transform: "translate(0 3.564)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2582",
    "data-name": "Group 2582"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4184",
    "data-name": "Path 4184",
    d: "M66,126.371l63.973,2.8-19.562-21Z",
    transform: "translate(-66 -101.187)",
    fill: "#dae0ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4185",
    "data-name": "Path 4185",
    d: "M103.363,107.614l-6.079,2.491,19.562,21,38.406,1.682,38.585-26.724-66.912-2.479C120.834,109.725,111.47,110.664,103.363,107.614Z",
    transform: "translate(-52.873 -103.115)",
    fill: "#cbcfdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4186",
    "data-name": "Path 4186",
    d: "M101.566,107.752c8.107,3.049,17.471,2.111,23.563-4.033l-12.579-.466Z",
    transform: "translate(-51.076 -103.253)",
    fill: "#dae0ed"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2581",
    "data-name": "Group 2581",
    transform: "translate(20.04 2.84)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4187",
    "data-name": "Path 4187",
    d: "M108.344,120.048l39.539,1.683,3.943-2.544-46.084-1.932Z",
    transform: "translate(-69.364 -100.217)",
    fill: "#b7bac8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4188",
    "data-name": "Path 4188",
    d: "M85.8,116.349l-5.68,2.42,38.98,1.659-2.6-2.793Z",
    transform: "translate(-80.117 -100.598)",
    fill: "#c6ccd9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4189",
    "data-name": "Path 4189",
    d: "M104.752,116.192l52.123,2.154,3.6-2.322-58.084-2.365Z",
    transform: "translate(-70.77 -101.727)",
    fill: "#b7bac8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4190",
    "data-name": "Path 4190",
    d: "M93.011,113.214l-5.193,2.213,23.049.952-2.361-2.534Z",
    transform: "translate(-76.885 -101.913)",
    fill: "#c6ccd9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4191",
    "data-name": "Path 4191",
    d: "M99.63,110.339l-4.766,2.031,8.5.342-2.152-2.31Z",
    transform: "translate(-73.928 -103.119)",
    fill: "#c6ccd9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4192",
    "data-name": "Path 4192",
    d: "M101.492,112.694l63.595,2.554,3.3-2.127L99.34,110.384Z",
    transform: "translate(-72.05 -103.101)",
    fill: "#b7bac8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4193",
    "data-name": "Path 4193",
    d: "M101.337,109.565l69.266,2.71,3.033-1.957-67.91-2.624Z",
    transform: "translate(-71.212 -104.229)",
    fill: "#b7bac8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4194",
    "data-name": "Path 4194",
    d: "M107.3,106.981l66.647,2.544,2.8-1.806-65.391-2.466Z",
    transform: "translate(-68.709 -105.254)",
    fill: "#b7bac8"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2584",
    "data-name": "Group 2584",
    transform: "translate(36.782 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4195",
    "data-name": "Path 4195",
    d: "M146.835,103.328l.2,3.908,2.162-.128a1.583,1.583,0,0,0,1.455-1.688l-.118-2.31Z",
    transform: "translate(-68.862 -99.748)",
    fill: "#96a6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4196",
    "data-name": "Path 4196",
    d: "M148.874,100.745l-2.163.128.176,3.45,3.7-.217-.094-1.85A1.557,1.557,0,0,0,148.874,100.745Z",
    transform: "translate(-68.914 -100.742)",
    fill: "#b6bec5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4197",
    "data-name": "Path 4197",
    d: "M99.071,108.852l.307-.018-.313-.092Z",
    transform: "translate(-88.907 -97.386)",
    fill: "#e2632a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4198",
    "data-name": "Path 4198",
    d: "M98.812,103.751l.3-.127-.307.018Z",
    transform: "translate(-89.016 -99.533)",
    fill: "#fe7031"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4199",
    "data-name": "Path 4199",
    d: "M158.365,103.707l-59.22,3.464.2,3.908,60.755-3.555,3.842-.225-.2-3.908Z",
    transform: "translate(-88.873 -99.63)",
    fill: "#f5ac09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4200",
    "data-name": "Path 4200",
    d: "M159.778,101.186l-60.755,3.555.175,3.451,59.22-3.464,5.378-.315-.175-3.451Z",
    transform: "translate(-88.925 -100.651)",
    fill: "#f9b316"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4201",
    "data-name": "Path 4201",
    d: "M146.972,100.872l-2.446.143.175,3.451,2.446-.144.657-.038-.175-3.451Z",
    transform: "translate(-69.831 -100.704)",
    fill: "#3f2566"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4202",
    "data-name": "Path 4202",
    d: "M147.1,103.3l-2.446.144.2,3.908,2.446-.144.657-.038-.2-3.907Z",
    transform: "translate(-69.779 -99.684)",
    fill: "#3f2566"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4203",
    "data-name": "Path 4203",
    d: "M92.536,106.555l-.627.265,6.709,1.972-.131-2.586Z",
    transform: "translate(-91.91 -98.45)",
    fill: "#424651"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4204",
    "data-name": "Path 4204",
    d: "M92.351,107.184l5.951-.349-.108-2.129Z",
    transform: "translate(-91.725 -99.079)",
    fill: "#585a60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4205",
    "data-name": "Path 4205",
    d: "M99.93,106.072l-3.387.2.131,2.586,3.449,1.013.313.092-.2-3.908Z",
    transform: "translate(-89.965 -98.513)",
    fill: "#edcd2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4206",
    "data-name": "Path 4206",
    d: "M99.793,103.751l-3.326,1.41.108,2.129,3.387-.2.307-.018-.175-3.451Z",
    transform: "translate(-89.997 -99.533)",
    fill: "#fcde48"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2585",
    "data-name": "Group 2585",
    transform: "translate(54.414 4.67)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4207",
    "data-name": "Path 4207",
    d: "M106.933,112.807l.183,2.8c1.312.119,3.357.3,6.993.622l-.332-5.084C110.219,112,108.216,112.49,106.933,112.807Z",
    transform: "translate(-103.238 -101.049)",
    fill: "#f9b316"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4208",
    "data-name": "Path 4208",
    d: "M153.4,116.073l5.222-.394,3-9.632-7.231.546Z",
    transform: "translate(-83.738 -103.186)",
    fill: "#f9b316"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4209",
    "data-name": "Path 4209",
    d: "M136.291,107.765l.632,9.632c.893-.034,1.792-.071,2.7-.112l-.643-9.814C138.074,107.566,137.181,107.666,136.291,107.765Z",
    transform: "translate(-90.918 -102.588)",
    fill: "#444147"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4210",
    "data-name": "Path 4210",
    d: "M111.552,112.255l.366,5.573c13.492-.254,22.686-.233,32.081-.518l-.613-9.361C134.046,109.078,124.945,110.48,111.552,112.255Z",
    transform: "translate(-101.3 -102.388)",
    fill: "#585a60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4211",
    "data-name": "Path 4211",
    d: "M161.954,105.473c-1.951-1.391-5.471-1.777-10.457-1.15-10.011,1.075-22.572,1.708-22.7,1.713,0,0,2.311,4.192,7.339,1.837,3.545-.26,18.7-.808,18.854-.813a3.433,3.433,0,0,1,1.77.457c.341.244.744.7.291,1.88-.373.965-.115,1.407.165,1.608,1.123.8,4.976-1.572,6.13-2.32l.148-.094.024-.185A3.287,3.287,0,0,0,161.954,105.473Z",
    transform: "translate(-94.062 -104.032)",
    fill: "#585a60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4212",
    "data-name": "Path 4212",
    d: "M133.976,108.063l.613,9.361c1.1-.034,2.2-.071,3.3-.114l-.632-9.632C136.159,107.8,135.066,107.932,133.976,108.063Z",
    transform: "translate(-91.89 -102.502)",
    fill: "#f9b316"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4213",
    "data-name": "Path 4213",
    d: "M138.187,108l.643,9.814c6.679-.305,13.908-.815,23.17-1.725q-.324-4.932-.646-9.862C152.064,106.712,144.841,107.294,138.187,108Z",
    transform: "translate(-90.123 -103.112)",
    fill: "#585a60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4214",
    "data-name": "Path 4214",
    d: "M106.434,112.778a8.68,8.68,0,0,0-2.1,1.219,10.737,10.737,0,0,0,2.009.777,10.324,10.324,0,0,0,1.87.335q-.092-1.4-.183-2.8A8.211,8.211,0,0,0,106.434,112.778Z",
    transform: "translate(-104.33 -100.556)",
    fill: "#444147"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbroad02);
export default __webpack_public_path__ + "static/media/abroad-02.710b9d1b72038b40d6caf09a7ff5263d.svg";
export { ForwardRef as ReactComponent };